const gridTemplateRows = {
  "10-auto": "repeat(10, auto)",
  "11-auto": "repeat(11, auto)",
  "12-auto": "repeat(12, auto)",
  "13-auto": "repeat(13, auto)",
  "14-auto": "repeat(14, auto)",
  "15-auto": "repeat(15, auto)",
}

module.exports = {
  gridTemplateRows,
}

exports.default = gridTemplateRows
